module.exports = __webpack_public_path__ + "img/paidfail.1ba5265b.png";